import { render, staticRenderFns } from "./ro_livechat_service.vue?vue&type=template&id=7e45de62&scoped=true&"
import script from "./ro_livechat_service.vue?vue&type=script&lang=js&"
export * from "./ro_livechat_service.vue?vue&type=script&lang=js&"
import style0 from "./ro_livechat_service.vue?vue&type=style&index=0&id=7e45de62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_shop_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45de62",
  null
  
)

export default component.exports